'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

require('../../src/styles/external.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addSpecialtiesToDropdown = function addSpecialtiesToDropdown(specialtiesList, setActiveOnClick, activeItem) {
  var specialties = [];
  for (var i = 0; i < specialtiesList.length; i++) {
    specialties.push(specialtiesList[i]);
  }
  return specialties.map(function (item, index) {
    return _react2.default.createElement(
      'li',
      { onClick: function onClick() {
          return setActiveOnClick(item);
        }, className: (activeItem ? _style2.default.listItemActive : '') + ' ' + _style2.default.listItem, key: index },
      item.name
    );
  });
};

var SpecialtiesList = function SpecialtiesList(props) {
  return _react2.default.createElement(
    'ul',
    { className: props.className },
    addSpecialtiesToDropdown(props.specialtiesList, props.setActiveOnClick, props.activeItem)
  );
};

SpecialtiesList.propTypes = {
  className: require('react').PropTypes.string.isRequired,
  specialtiesList: require('react').PropTypes.arrayOf(require('react').PropTypes.object).isRequired,
  setActiveOnClick: require('react').PropTypes.func.isRequired,
  activeItem: require('react').PropTypes.any.isRequired
};
SpecialtiesList.displayName = 'SpecialtiesList';

SpecialtiesList.defaultProps = {
  className: 'SpecialtiesList'
};

exports.default = SpecialtiesList;


// WEBPACK FOOTER //
// ./components/sign-up-modal/lib/components/specialties-list.js